import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import auth0 from './plugins/auth0';
import { loadFonts } from './plugins/webfontloader';

loadFonts();

if (process.env.DEBUG && process.env.DEBUG_JWT) {
  store.dispatch('main/setToken', { token: process.env.DEBUG_JWT });
  store.dispatch('setFeatureFlags', {
    tracker: true,
    search_navbar: true,
    redirect_new_lists: true,
  });
}

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(auth0)
  .mount('#mainapp');
